import { AppContextType } from "../../../../context/AppContext"
import useAppContext from "../../../../hooks/useAppContext"
import { ChangeSocialObjectType } from "../../../../static/types/changeSocialObjective/changeSocialObjectType"
import { DateType } from "../../../../static/types/commonTypes/dateType"
import ChangeSocialObject from "../../../change-social-object/ChangeSocialObject"
import DateComponent from "../../../commonComponents/DateComponent"

const ChangeObject = () => {

    const {
        socialObjectChangeEffectiveDate,
        setSocialObjectChangeEffectiveDate,
        setSocialObjectChangeEffectiveDateValidity,
        socialObjectChangeEffectiveDateChecked,

        socialObjectChange,
        setSocialObjectChange,

        changeSocialObject, setChangeSocialObject,
        setChangeSocialObjectValidity,
        changeSocialObjectChecked,

    } = useAppContext() as AppContextType

    const updateDate = (data: Partial<DateType>) => setSocialObjectChangeEffectiveDate({...socialObjectChangeEffectiveDate,...data})

    return (
        <div>
            <div className='col-sm-10 d-flex align-items-center mt-1'>
                <label htmlFor="denomination" className="col-sm-2 col-form-label mb-0">
                    Modification
                </label>
                <select
                    className='form-select w-75'
                    id="denomination"
                    onChange={(e) => setSocialObjectChange(Number(e.target.value))}
                    value={socialObjectChange}
                >
                    <option value={0}>Aucune modification</option>
                    <option value={1}>Adjonction</option>
                    <option value={2}>Modification</option>
                </select>
            </div>
            
            {
                socialObjectChange !== 0 &&
                    <div className="mt-3">
                        <div className="col-sm-7">
                            <DateComponent
                            id="date-effet-object"
                            date = { socialObjectChangeEffectiveDate }
                            draftFieldName = "socialObjectChangeEffectiveDate"
                            changeDate = { updateDate }
                            dateLabel = "Date d'effet"
                            checked = { socialObjectChangeEffectiveDateChecked }
                            onValidationChange = {( isValid: boolean ) => setSocialObjectChangeEffectiveDateValidity( isValid )}
                            required = { false }
                        />
                        </div>
                        
                        <ChangeSocialObject
                            labelText="Objet social"
                            showTypeSelect = { false }
                            showRequiredIndicator = { false }
                            checked = { changeSocialObjectChecked }
                            socialObject = { changeSocialObject }
                            onValidationChange = {( isValid: boolean ) => setChangeSocialObjectValidity( isValid )}
                            changeSocialObject = {( partialData: Partial<ChangeSocialObjectType>) => setChangeSocialObject({ ...changeSocialObject, ...partialData })}
                        />
                    </div>
            }
        </div>
    )
}

export default ChangeObject